module.exports = __webpack_public_path__ + "static/media/wP.e38a4f66.svg";